import { InjectionToken } from "@angular/core";
import { IAffiliationData } from "../interfaces/AffiliationData.type";


export const AFFILIATION_DATA = new InjectionToken<IAffiliationData>('affiliationData'); 